import { addDays, addWeeks, differenceInCalendarWeeks, format, parseISO, startOfWeek, subWeeks } from 'date-fns';
import { WEEK_STARTS_ON, WORK_WEEKDAYS } from '../modules/shift-management/schedulingConfig';

export function todayDateKey(date = new Date()): string {
  return format(date, 'yyyy-MM-dd');
}

/** Past dates allowed for office punch corrections (default: 8 weeks). */
export function correctionDateMinKey(weeksBack = 8): string {
  return format(subWeeks(new Date(), weeksBack), 'yyyy-MM-dd');
}

export function correctionDateMaxKey(): string {
  return todayDateKey();
}

export function isSelectableCorrectionDate(dateKey: string, weeksBack = 8): boolean {
  return dateKey <= correctionDateMaxKey() && dateKey >= correctionDateMinKey(weeksBack);
}

export function getWeekStartKeyForOffset(offset: number): string {
  return format(
    addWeeks(startOfWeek(new Date(), { weekStartsOn: WEEK_STARTS_ON }), offset),
    'yyyy-MM-dd'
  );
}

export function getWeekOffsetForDateKey(dateKey: string): number {
  const anchor = startOfWeek(new Date(), { weekStartsOn: WEEK_STARTS_ON });
  const target = startOfWeek(parseISO(`${dateKey}T12:00:00`), { weekStartsOn: WEEK_STARTS_ON });
  return differenceInCalendarWeeks(target, anchor, { weekStartsOn: WEEK_STARTS_ON });
}

export function getWorkWeekDateKeys(weekStartKey: string): string[] {
  const monday = parseISO(`${weekStartKey}T12:00:00`);
  return WORK_WEEKDAYS.map((_, index) => format(addDays(monday, index), 'yyyy-MM-dd'));
}

export function formatPunchTime(iso: string): string {
  return format(new Date(iso), 'HH:mm');
}

export function formatPunchDate(iso: string): string {
  return format(new Date(iso), 'yyyy-MM-dd');
}

export function isoToTimeInputValue(iso: string): string {
  return format(new Date(iso), 'HH:mm');
}

export function parseTimeOnDate(timeHHmm: string, dateKey = todayDateKey()): string {
  const [hours, minutes] = timeHHmm.split(':').map(Number);
  const date = new Date(`${dateKey}T12:00:00`);
  date.setHours(hours, minutes, 0, 0);
  return date.toISOString();
}
